import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    section_id: false,
    section: {},
    product_total: 0,
    noMoreProducts: false
  },
  actions: {
    async fetchSimilarProducts({ commit, state }, id) {
        commit('RESET_STATE');


      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/catalog/detail/'+id+'/similar/');
        if (response?.data?.data) {
          commit('SET_DATA', {data: response.data.data});
          commit('SET_ERROR', null);
        }
        else {
          if (response?.data?.errors && Array.isArray(response.data.errors)) {
            // Проверяем есть ли в массиве ошибки с числовым кодом или code_error
            const hasTechnicalError = response.data.errors.some(
                error => typeof error.code === 'number' || error.code === 'code_error'
            );

            if (hasTechnicalError) {
              commit('SET_ERROR', 'Техническая ошибка');
            } else {
              const errorMessages = response.data.errors
                  .map(error => error.message)
                  .join('. ');

              commit('SET_ERROR', errorMessages);
            }
          } else {
            commit('SET_ERROR', 'Произошла ошибка при выполнении операции');
          }


        }

      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    similar_products: state => state.data,
    similar_productsLoading: state => state.loading,
    similar_productsError: state => state.error,
    similar_productsLoaded: state => state.loaded
  }
})